import $ from "jquery";
$(document).ready(function () {
    $(".story-intro").on("mouseenter", function () {
        const random = Math.random() * (9999999999 - 1000000000) + 1000000000;
        $(this).find(".story-intro__svg > source").attr("srcset", (i, val) => val.replace(/v=([^&]*)/, "v=" + random));
        $(this).find(".story-intro__svg > img").attr("src", (i, val) => val.replace(/v=([^&]*)/, "v=" + random));
    });
    let history = document.getElementById('our-history-animation');
    if (history) {
        const historyContainer = $('#our-history-animation')
        let observer = new IntersectionObserver(
            ([entry]) => {
                if (entry.intersectionRatio > 0) {
                    historyContainer.addClass('loaded')
                    observer.unobserve(entry.target);
                }
            },
            {root: null, rootMargin: "0px", threshold: .5}
        );
        observer.observe(history);
        historyContainer.on('mousemove', e => {
            const rect = history.getBoundingClientRect()
            const MOUSE_X = e.clientX - rect.x
            const MOUSE_Y = e.clientY - rect.y
            const ORIGIN_X = rect.width / 2
            const ORIGIN_Y = rect.height / 2
            const x = ((MOUSE_X - ORIGIN_X) / ORIGIN_X) * 50 * -0.05
            const y = ((MOUSE_Y - ORIGIN_Y) / ORIGIN_Y) * 50 * -0.05
            // const x = MOUSE_X > ORIGIN_X ? 5 : -5
            // const y = MOUSE_Y > ORIGIN_Y ? 5 : -5
            historyContainer.find('.history-items').css('transition', `none`)
            historyContainer.find('.history-items').css('transform', `translate(${x}%, ${y}%)`)
        })
        historyContainer.on('mouseleave', () => {
            historyContainer.find('.history-items').css('transition', `transform 1s`)
            historyContainer.find('.history-items').css('transform', `none`)
        })
        $(`.history-items-1912 .history-item`).each(function (i, item) {
            const delay = 2.3 + i * .3
            $(item).css('transition', `transform .5s ease ${delay}s, opacity .5s ease ${delay}s, margin .5s`)
        })
        const navButtons = $('.history__nav button')
        navButtons.on('click', e => {
            const button = $(e.target)
            const layer = $('.history__layers .year')
            const prevYear = layer.attr('data-id')
            const nextYear = button.attr('data-year')
            navButtons.removeClass('active')
            button.addClass('active')
            layer.attr('class', 'year active')
            layer.addClass('year-' + button.attr('data-year'))
            layer.attr('data-id', button.attr('data-year'))
            historyContainer.attr('data-year', button.attr('data-year'))

            $(`.history-items-${prevYear} .history-item`).each(function (i, item) {
                const delay = i * .1
                $(item).css('transition', `transform .3s ease ${delay}s, opacity .3s ease ${delay}s, margin .3s`)
            })

            $(`.history-items-${nextYear} .history-item`).each(function (i, item) {
                const offset = $(`.history-items-${prevYear} .history-item`).length * .3 * .5
                const delay = offset + i * .1
                $(item).css('transition', `transform .3s ease ${delay}s, opacity .3s ease ${delay}s, margin .3s`)
            })
        })
    }
})
